import React, { useState } from "react";
import PickAndPackProvider from "./PickAndPackProvider"
import ViewBnOrders from "./ViewBnOrders"

const ViewSetReceivedManually = () => {
    return <PickAndPackProvider>
        <ViewBnOrders lockedSide="Sell" deliveryStatusFixed="Completed" userAction="SetReceivedManually" />
    </PickAndPackProvider>
}

export default ViewSetReceivedManually